import { render, staticRenderFns } from "./passBtn.vue?vue&type=template&id=214b047f&"
import script from "./passBtn.vue?vue&type=script&lang=ts&"
export * from "./passBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports